<!-- 
  详情页 - 退货产品信息
  props:
    id: 详情id
 -->

<template>
  <div class="v-tabs product-list">
    <div class="head" v-if="totalMsg">
      <div class="total">
        {{totalMsg}}
      </div>
      <div class="inline-item">
        退款总计：<span class="red">{{totalAmount}}</span>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        border
        highlight-current-row
        style="width: 100%"
        @click.native="tableClick">
        <el-table-column
          label="序号"
          type="index"
          width="55">
        </el-table-column>
        <el-table-column
          label="产品图片"
          width="100"
        >
        <template slot-scope="scope">
          <img
            data-type="img"
            :data-url="scope.row.thumbnail || scope.row.thumbNail"
            :src="scope.row.thumbnail || scope.row.thumbNail"
            height="30"
            width="30">
        </template>
        </el-table-column>
        <el-table-column
          label="产品名称"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.productName}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="productNo"
          label="产品编号"
          width="80"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          label="产品规格"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.specification || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="num"
          label="数量"
          width="80"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          property="memo"
          label="备注"
          width="80"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.memo || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="单位"
          width="80"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{scope.row.unit || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          property="price"
          :label="'单价 ('+unit+')'"
          width="80"
          show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          width="90"
          property="productPrice"
          :label="'折扣价 ('+unit+')'"
          show-overflow-tooltip>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'
import lightBox from 'src/plugins/lightbox'

export default {
  created () {
    this.getList()
  },
  props: {
    id: Number,
    approvalId: Number
  },
  data () {
    return {
      tableData: [],
      // 商品信息
      totalMsg: '',
      // 费用总计
      totalAmount: '0元',
      unit: '元'
    }
  },
  computed: {
    // 产品总数
    totalProducts () {
      let i = 0
      this.tableData.forEach(item => {
        i += item.num
      })
      return i
    },
    // 合同金额总计
    totalPrice () {
      let i = 0
      this.tableData.forEach((item) => {
        // i += item.productPrice * item.num
        let mult = utils.multiply(item.productPrice, item.num)
        i = utils.plus(i, mult)
      })
      return i
    }
  },
  methods: {
    getList () {
      let url
      if (this.approvalId) {
        url = '/refund/getRefundProducts.html'
      } else {
        url = '/contractApi/getRedContractProducts.html'
      }
      let params = {
        id: this.id
      }
      api.post(url, params, (data) => {
        if (this.approvalId) {
          this.tableData = data.productList
          this.totalMsg = data.totalMsg
          this.totalAmount = data.totalAmount
        } else {
          this.tableData = data.result.list
          this.totalMsg = data.result.totalMsg
          this.totalAmount = data.result.totalAmount
          this.unit = data.result.unit
        }
      })
    },
    // 监听table点击事件
    tableClick (event) {
      // 获取目标元素或目标父元素的data属性集合
      let data = event.target.dataset
      // 如果存在type属性，则是一个可执行的事件
      if (data.type && data.type === 'img') {
        lightBox(data.url)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// product-list.vue?2bf1cd74